import React, { Component } from 'react';
import startCase from 'lodash/startCase';
import getResultMessage from './getResultMessage';
import './Results.css';

class Results extends Component {
  render() {
    const message = getResultMessage(this.props.score)
      .replace('Cultivating the Strategic Mind', '<i>Cultivating the Strategic Mind</i>');
    return (
      <div className="results">
        <h2>Self-Assessment Results for {startCase(this.props.name)}:</h2>
        <p className="body">
          Thank you for taking the <i>Strategic Mind Self-Assessment</i>.
          Your participation in this assessment is indicative of a learning mindset. Congratulations—this, in and
          of itself, is a key step in becoming a more exemplary strategist.
        </p>
        <p><b>Your Score is: {this.props.score} out of 125</b></p>
        <p dangerouslySetInnerHTML={{__html: message}}></p>
      </div>
    );
  }
}

Results.propTypes = {
  name: React.PropTypes.string,
  score: React.PropTypes.number,
};

export default Results;



// WEBPACK FOOTER //
// ./src/Results.js